export class MeterNotFoundError extends Error {
  constructor() {
    super("Provided meter was not found.");
    this.name = "MeterNotFoundError";
  }
}
